import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { ErrorResponse } from '@model/error.model';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  constructor(private http: HttpClient) {}

  downloadPolicy(epolicyId: string): Observable<BlobPart> {
    const url = `${environment.endpoint.epolicyAPI}/documents/policy?ePolicyId=${epolicyId}`;

    const options: any = {
      responseType: 'blob' as 'text'
    };

    return this.http.get(url, options).pipe(
      catchError((e: HttpErrorResponse) => {
        const errorResp: ErrorResponse = JSON.parse(e.error.text());

        return throwError(() => errorResp);
      })
    );
  }
}
